import { render, staticRenderFns } from "./policy-information.vue?vue&type=template&id=1111608e&"
import script from "./policy-information.vue?vue&type=script&lang=js&"
export * from "./policy-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports